import { Navigate, Outlet } from "react-router-dom";

const RedirectsAdmins = ({
  isAllowed,
  redirectPath = "/admin/dashboard",
  children,
}) => {
  if (isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};

export default RedirectsAdmins;
